// @ts-ignore
export const bodyScroll = {
   prevent() {
     // @ts-ignore
     document.querySelector("body").style.overflow = "hidden";
   },
   allow() {
     // @ts-ignore
     document.querySelector("body").style.overflow = null;
   },
 };
